import {
  ESC_KEY
} from './const';
import {
  showMessage,
  debounce,
  getResponseByMode
} from './utils';

export const search = {
  init: function () {
    this._formSearch = document.querySelector('.form-search');
    if (this._formSearch === null) {
      return;
    }
    this._toggleBtn = document.querySelector('.header-mobile__link--search');
    if (this._toggleBtn !== null) {
      this._toggleBtnClick = this._toggleBtnClick.bind(this);
      this._toggleBtn.addEventListener('click', this._toggleBtnClick);
    }

    this._container = this._formSearch.querySelector('.form-search__container');
    this._closeBtn = this._formSearch.querySelector('.form-search__close');
    this._searchInput = this._formSearch.querySelector('.form-search__input');
    this._resetBtn = this._formSearch.querySelector('.form-search__reset');
    this._overlay = document.querySelector('.overlay');
    this._data = null;
    this._type = this._getType();

    this._closeBtnClick = this._closeBtnClick.bind(this);
    this._searchInputInput = this._searchInputInput.bind(this);
    this._searchFocusInput = this._searchFocusInput.bind(this);
    this._resetBtnClick = this._resetBtnClick.bind(this);
    this._overlayBtnClick = this._overlayBtnClick.bind(this);
    this._loadResults = debounce(this._loadResults.bind(this));
    this._documentKeydownHandler = this._documentKeydownHandler.bind(this);
    this._documentClickHandler = this._documentClickHandler.bind(this);

    this._closeBtn.addEventListener('click', this._closeBtnClick);
    this._searchInput.addEventListener('input', this._searchInputInput);
    this._searchInput.addEventListener('focus', this._searchFocusInput);
    this._resetBtn.addEventListener('click', this._resetBtnClick);
    this._overlay.addEventListener('click', this._overlayBtnClick);
  },

  show: function () {
    this._formSearch.classList.add('form-search--opened');
    if (this._type === 'mobile') {
      this._overlay.classList.add('overlay--show');
    }
    this._searchInput.focus();
  },

  hide: function () {
    this._formSearch.classList.remove('form-search--opened');
    if (this._type === 'mobile') {
      this._overlay.classList.remove('overlay--show');
    }
  },

  showSuggest: function () {
    this._formSearch.classList.add('form-search--active');

    document.addEventListener('keydown', this._documentKeydownHandler);
    document.addEventListener('click', this._documentClickHandler);
  },

  hideSuggest: function () {
    this._removeResults();
    this._formSearch.classList.remove('form-search--active');

    document.removeEventListener('keydown', this._documentKeydownHandler);
    document.removeEventListener('click', this._documentClickHandler);
  },

  _toggleBtnClick: function () {
    this._toggle();
  },

  _toggle: function () {
    if (this._formSearch.classList.contains('form-search--opened')) {
      this.hide();
    } else {
      this.show();
    }
  },

  _closeBtnClick: function () {
    this._resetBtnClick();
    this.hide();
  },

  _searchInputInput: function () {
    if (this._searchInput.value === '') {
      this.hideSuggest();
    } else if (this._searchInput.value.length > 2) {
      this._showLoaders(true);
      this._loadResults();
    }
  },

  _searchFocusInput: function () {
    this.show();
  },

  _resetBtnClick: function () {
    this._searchInput.value = '';
    this.hideSuggest();
  },

  _overlayBtnClick: function () {
    this._removeResults();
    this.hide();
  },

  _documentKeydownHandler(evt) {
    if (evt.key === ESC_KEY) {
      this.hideSuggest();
    }
  },

  _documentClickHandler(evt) {
    if (!this._isParent(evt)) {
      this.hideSuggest();
    }
  },

  _loadResults: async function () {
    try {

      const mock = {
        url: 'mocks/search.json',
        options: {
          method: 'GET',
        },
      };

      const real = {
        url: '/shop/search/quick_search',
        options: {
          method: 'POST',
          body: new FormData(search._formSearch)
        }
      };

      const {
        url,
        options
      } = getResponseByMode(mock, real);

      const response = await fetch(url, options);

      if (!response.ok) {
        throw new Error('Неуспешный запрос');
      }
      const data = await response.json();
      search._renderResults(data);
      search.showSuggest();
    } catch (error) {
      console.warn(error);
      showMessage(error.message);
    } finally {
      this._showLoaders(false);
    }
  },

  _renderResults: function (data) {
    this._data = data;
    const template = document.querySelector('#search-list-data').content.querySelector('.header-suggestion');
    const cloneTemplate = template.cloneNode(true);
    const containerCloneTemplate = cloneTemplate.querySelector('.header-suggestion__list');
    if (this._data !== null) {
      const linkResult = this._createResultLink();
      const listResult = this._createListResult();
      containerCloneTemplate.appendChild(linkResult);
      containerCloneTemplate.appendChild(listResult);
    }
    this._removeResults();
    this._container.appendChild(cloneTemplate);
  },

  _createResultLink: function () {
    const template = document.querySelector('#results-data').content.querySelector('.header-suggestion__item');
    const cloneTemplate = template.cloneNode(true);
    cloneTemplate.querySelector('.header-suggestion__link').href = this._data.all;
    cloneTemplate.querySelector('.header-suggestion__found').textContent = this._data.count;
    return cloneTemplate;
  },

  _createListResult: function () {
    const template = document.querySelector('#search-item-data').content.querySelector('.header-suggestion__item');
    const fragment = document.createDocumentFragment();
    const products = this._data.products;
    products.forEach((it) => {
      const cloneTemplate = template.cloneNode(true);
      cloneTemplate.querySelector('.header-suggestion__link').href = it.link;
      cloneTemplate.querySelector('.header-suggestion__img').src = it.image;
      cloneTemplate.querySelector('.header-suggestion__img').alt = it.name;
      cloneTemplate.querySelector('.header-suggestion__title').textContent = it.name;

      fragment.appendChild(cloneTemplate);
    });
    return fragment;
  },

  _removeResults: function () {
    if (this._container.querySelector('.header-suggestion')) {
      this._container.querySelector('.header-suggestion').remove();
    }
  },

  _showLoaders: function (boolean) {
    if (boolean) {
      this._formSearch.classList.add('form-search--loaded');
      this._closeBtn.textContent = 'Ищем ...';
    } else {
      this._formSearch.classList.remove('form-search--loaded');
      this._closeBtn.textContent = 'Закрыть';
    }
  },

  _isParent: function (evt) {
    return evt.target.closest(`.${this._formSearch.classList[0]}`);
  },

  _getType: function () {
    return this._formSearch.closest('.header-mobile') ? 'mobile' : 'desktop';
  }
};
